import {
    creteNewSite,
    fetchActivitiesDocuments,
    fetchAlertSite,
    fetchFormSchema,
    fetchGrouperActivities,
    formSchemaEdit,
    gropuerSelected,
    resetFormSchemaEdit,
} from './actions';

export const siteActions = {
    fetchAlertSite,
    fetchGrouperActivities,
    fetchFormSchema,
    gropuerSelected,
    creteNewSite,
    formSchemaEdit,
    resetFormSchemaEdit,
    fetchActivitiesDocuments,
};
